// John Eldhose 20190503
import { RestfulPost } from './Restful';

export async function getCache(option) {
  const cache = await RestfulPost('getCache', {option: option}, (response) => {
      return response['data'];
    }, (error) => {
      console.log(error);
      return false;
    }
  );
  return cache;
}



// WEBPACK FOOTER //
// ./src/Api/getCache.js